// Solar
export const MAX_SOLAR_TIME_UNITS_TOTAL = 10000;
export const SOLAR_MONTHS_MIN = 1;
export const SOLAR_MONTHS_MAX = 12;
export const SOLAR_DAYS_MIN = 1;
export const SOLAR_DAYS_MAX = 30;
export const SOLAR_HOURS_MIN = 1;
export const SOLAR_HOURS_MAX = 24;
export const SOLAR_MINUTES_MIN = 1;
export const SOLAR_MINUTES_MAX = 60;

// Target view
export const DEFAULT_TARGET_VIEW_RAYS_NUMBER = 2000;
export const MIN_TARGET_VIEW_RAYS_NUMBER = 100;
export const MAX_TARGET_VIEW_RAYS_NUMBER = 10000;
export const FOREST_MIN_AREA_DEFAULT = 1000;
export const FOREST_MIN_AREA_MIN = 100;
export const FOREST_MIN_AREA_MAX = 5000;
export const TARGET_VIEW_RADIUS_MIN = 100;
export const DEFAULT_TARGET_VIEW_RADIUS_MAX = 5500;
export const TARGET_WATER_OVERPASS_TIMEOUT_SECONDS = 20;
export const TARGET_RIVER_RADIUS_METERS = 1000;

// Wind
export const MAX_WIND_AVERAGE_BUILDING_HEIGHT = 200;
export const MAX_WIND_SENSOR_HEIGHT_FROM_GROUND = 100;
export const MAX_WIND_SPEED = 50;
export const WIND_ROSES_BASE_PATH = '/remote_assets/wind-roses-per-station';

// Noise
export const LINE_SOURCE_SPACING_RATIO_LOW = 2;
export const LINE_SOURCE_SPACING_RATIO_NORMAL = 3;
export const LINE_SOURCE_SPACING_RATIO_HIGH = 4;
export const DEFAULT_LINE_SOURCE_SPACING_RATIO = LINE_SOURCE_SPACING_RATIO_NORMAL;
export const MAX_LINE_SOURCE_SPACING_RATIO = 10;
export const MIN_NOISE_SOURCE_DISTANCE = 1;
export const DEFAULT_NOISE_SOURCE_DISTANCE = 300;
export const MAX_NOISE_SOURCE_DISTANCE_WITH_REFLECTION_AND_HORIZONTAL_DIFFRACTION = 150;
export const DEFAULT_NUMBER_OF_REFLECTIONS = 0;
export const MIN_NUMBER_OF_REFLECTIONS = 1;
export const MAX_NUMBER_OF_REFLECTIONS = 3;
export const MIN_REFLECTED_SOURCE_DISTANCE = 1;
export const MAX_REFLECTED_SOURCE_DISTANCE = 100;
export const DEFAULT_MAX_REFLECTED_SOURCE_DISTANCE = 50;
export const NOISE_ROADS_VALIDATION_RADIUS_METERS = 500;

export const LINE_SOURCE_SPACING_RATIO_SLIDER_VALUES = [
  LINE_SOURCE_SPACING_RATIO_LOW,
  LINE_SOURCE_SPACING_RATIO_NORMAL,
  LINE_SOURCE_SPACING_RATIO_HIGH,
];

// Shadow
export const SHADOW_NOT_DEFINED_MESSAGE =
  'Shadow simulation has not been defined, define the mandatory parameters or unflag it.';

// Shared simulation flow
export const SIMULATION_PROGRESS_POLL_INTERVAL_MS = 3000;
